<template>
	<section class="bg-neutral-50">
		<div class="py-20 px-4 mx-auto max-w-screen-xl md:py-30 lg:px-6">
			<div class="mx-auto max-w-screen-md sm:text-center">
				<h3
					class="mb-5 text-3xl tracking-tight font-bold text-slate-950 sm:text-4xl text-center"
				>
					{{ getTranslations("Interested in our solutions?") }}
				</h3>
				<p
					class="mx-auto mb-8 max-w-md text-slate-950 md:mb-15 text-base leading-6.5"
				>
				{{ getTranslations("Get in touch with our team to learn more about how we can help optimize your operations.") }}
				</p>
				<div class="mx-auto mb-3">
					<div class="flex justify-center">
						<a href="https://www.solenis.com/en/contact/contact-us/"
							class="py-3 px-8 rounded-xl bg-blue-400 text-base font-medium text-center text-white border cursor-pointer bg-primary-700 border-primary-600 hover:bg-blue-500 transition-colors duration-200 capitalize" 
						>
							{{ getTranslations("Contact us") }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
	name: "HomeNewsletter",
	computed: {
		...mapGetters("staticContent", ["getTranslations"]),
	},
};
</script>
